import { OpenDesignStateActions, SET_SHOW_OPEN_DESIGN, SET_OPEN_DESIGN_INPUT } from './types';

export function setShowOpenDesign(value: boolean): OpenDesignStateActions {
	return {
		type: SET_SHOW_OPEN_DESIGN,
		value,
	};
}

export function setOpenDesignInput(value: string): OpenDesignStateActions {
	return {
		type: SET_OPEN_DESIGN_INPUT,
		value,
	};
}
